import { TimezoneEntity } from 'api/types/entity';
import { secondsToTime } from 'helpers';

export const getTimezoneLabel = (v: TimezoneEntity) => {
  const { hoursString, minutesString } = secondsToTime(Math.abs(v.gmtOffset));
  const sign = v.gmtOffset >= 0 ? '+' : '-';

  return `(GMT ${sign}${hoursString}:${minutesString}) ${v.name}`;
};
